<template>
<div :class="['theme_'+$store.state.common.theme]" >
  <div class="backIndex" v-if="showback_icon">
    <img @click="backIndex" src="./assets/images/btn_back_home.png" alt="">
  </div>
  <transition :name="viewAnimate">
    <keep-alive>
      <navigation  >
        <router-view v-if="isNetworkOnline && flag" class="router_Page" v-wechat-title="$route.meta.title"/>
        <!-- <no-network v-if="!isNetworkOnline"></no-network> -->
      </navigation>
    </keep-alive>
  </transition>
</div>
</template>

<script>
// import noNetwork from '@/components/NotFound.vue';
import {
  getWapOpenId,
  getAppId,
  statistics,
  getShareInfo,
  getMarketList,
  getUserMarketInfo
} from './utils/api';
import util from './utils/util';
import storage from './utils/storage';
import {mapState,mapActions} from 'vuex';
import wx from 'weixin-js-sdk'


export default {
  name: 'App',
  components: {
    // noNetwork
  },
  data () {
    return {
      viewAnimate: '',
      isNetworkOnline: false,
      timeLate:false,
      enterTime: 0,
      leaveTime: 0,
      curTitle: '首页',
      firstLogin: 1,
      showback_icon:false
    };
  },
  computed: {
    ...mapState({
      flag: state => state.common.flag,
      common: state => state.common
    })
  },
  watch: {
    $route (to, from) {
      util.hideLoading()
      // 如果是安卓手机,如果需要分享好友,请求
      // if(this.timeLate)
      let u = window.navigator.userAgent;
      if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
        if(to.meta.share){
          wx.showOptionMenu()
          this.getShareInfo()
        }else{
          wx.ready(()=>{
            wx.hideOptionMenu()
          })
        }
      }else{
        if(to.meta.share != from.meta.share){
          if(to.meta.share){
            wx.ready(()=>{
              wx.showOptionMenu()
              // this.getShareInfo()  //新改版后iOS 也需要重新请求
              wx.hideMenuItems({
                menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
              });
            })
          }else{
            wx.ready(()=>{
              wx.hideOptionMenu()
            })
          }
        }
      }
      // 判断是否显示回到首页按钮
      console.log(" in $routechange")
      this.getGoindex(this.common.goindex+1);
      console.log( "this.common.goindex   =====   " + this.common.goindex)
      if(this.common.goindex==0 &&
         (this.$route.query.marketId|| this.$route.query.cityId)&&
        this.$route.fullPath.indexOf('home') < 0 &&
        this.$route.fullPath.indexOf('/activity?') < 0 &&
        this.$route.fullPath.indexOf('/me?') < 0 &&
        this.$route.fullPath.indexOf('/evaluateSm?') < 0 &&
        !this.$route.query.come
      ){
        this.showback_icon = true
      }else{
        this.showback_icon = false
      }
      this.curTitle = to.meta.title;
       if (this.common.userId) {
          if(from.path=="/login"){ //登录页面单独记录
             var title = "登录";
             this.statistics(from.path, title)
          }
          var title1 = to.meta.title;
          if(to.path=="/home"){
              title1 ="首页";
          }
          this.statistics(to.path, title1)
        // this.statistics(from.path, from.meta.title)
       }
      if (to.meta.index === 0 && from.meta.index === 0) {
        this.viewAnimate = '';
      }
    }
  },
  created () {
    this.$navigation.on('forward', () => {
      this.viewAnimate = 'slide-left'
    })
    this.$navigation.on('back', () => {
      this.viewAnimate = 'slide-right'
    })
    this.$navigation.on('replace', () => {
      this.viewAnimate = 'slide-left'
    })
    // setTimeout(() => {
    //      this.timeLate =true
    // }, 2000);
    if(this.$route.query.cityId){
          this.setCityId(this.$route.query.cityId)
          this.getMarketListFun(this.$route.query.cityId)
     }

    // 判断是否显示回到首页按钮
    if(this.common.goindex==0 &&
      (this.$route.query.marketId|| this.$route.query.cityId) &&//有项目id
      !this.$route.query.come &&//不是企业微信来的页面
      this.$route.fullPath.indexOf('home') < 0 &&//首页
      this.$route.fullPath.indexOf('/activity?') < 0 &&//发现页
      this.$route.fullPath.indexOf('/me?') < 0 &&//我的页面
      this.$route.fullPath.indexOf('/evaluate?') < 0 &&//评价页
      this.$route.fullPath.indexOf('/officeApproval') < 0 &&//办公耗材审批
      this.$route.fullPath.indexOf('/myAppointDetail') < 0 //家政服务订单详情-短信入口
    ){
      this.showback_icon = true
    }else{
      this.showback_icon = false
    }
    this.enterTime = new Date().valueOf()
    // 直接进入到H5页面,不请求微信接口
    if(
      this.$route.path === '/meetingApproval' ||
      this.$route.path === '/officeApproval' ||
      this.$route.path === '/myOfficeWxOrder' ||
      this.$router.path==='/shotPhoto' ||
      this.$route.path === '/myAppointDetail' && (this.$route.query.come || !this.$route.query.marketId) ||
      this.$route.path.indexOf('/visitAccessCard') > -1 ||
      this.$route.path.indexOf('/evaluateSm') > -1 ||
      this.$route.path.indexOf('/handleConsultation') > -1 ||
      this.$route.path.indexOf('/viewEvaluate') > -1 ||
      this.$route.path.indexOf('/WaterSignMian') > -1 ||
      this.$route.path.indexOf('/WaterSignIndex') > -1 ||
      this.$route.path.indexOf('/WaterMeetingMian') > -1 ||
      this.$route.path.indexOf('/WaterMeetingIndex') > -1
      ){
      this.getFlag(true)
      this.getShareInfo();
      return false;
    }
    // 页面刷新判断当前是否有用户数据
    let userMess = storage.getS("userData") || '';
    if(userMess){
      this.setUserInfo()
      return;
    }
    let href = window.location.href;
    console.log('href ==== ' + href)
    if (href.indexOf(".com")>-1) {
      let local = window.location.href;

      let code = storage.get('code') || '';
      // 页面刷新,取本地项目id缓存,避免刷新无效
      let marketId = storage.get('marketId') || '';
      if (!this.$route.query.code || code === this.$route.query.code) {
        if(this.$route.fullPath.indexOf('home') > -1){
          if(this.$route.query.cityId){
            local = window.location.href.split('?')[0]+'?cityId='+this.$route.query.cityId
          }else{
            local = window.location.href.split('?')[0]+'?marketId='+this.$route.query.marketId || marketId
          }
        }
        // 先使用marketId,如果获取不到appid,再试cityId
        if(this.$route.query.marketId){
          getAppId({marketId: this.$route.query.marketId || marketId}).then(res => {
            if (res.res.code === 10000 && res.body && res.body.appid) {
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
              if(this.$route.query.cityId){
                getAppId({cityId:this.$route.query.cityId},{cityId:this.$route.query.cityId}).then(res => {
                  if (res.res && res.res.code === 10000) {
                    if(local.indexOf('owner') == -1){
                      local = local + '&owner=1'
                    }
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
                  } else {
                    this.getFlag(true)
                    util.showToast(res.res.msg)
                  }
                })
              }else{
                 console.log('有 marketId 没cityId')
                 util.showToast(res.res.msg)
              }
            }
          })
        }else {
          getAppId({cityId:this.$route.query.cityId},{cityId:this.$route.query.cityId}).then(res => {
            if (res.res && res.res.code === 10000) {
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
              this.getFlag(true)
              console.log('没有 marketId 有cityId')
              util.showToast(res.res.msg)
            }
          })
        }
      } else {
        storage.set('code', this.$route.query.code)
        if(this.$route.query.marketId || marketId){
          storage.set('marketId', this.$route.query.marketId || marketId)
        }
        // owner=1,消息模版进来,且该项目未能获取openid
        if(this.$route.query.owner == '1'){
          this.setCityId(this.$route.query.cityId)
          storage.setS("cityId",this.$route.query.cityId)
          this.getWapOpenId({
            jsCode: this.$route.query.code,
            cityId: this.$route.query.cityId
          },{})
        }else{
          if(this.$route.query.cityId && !this.$route.query.marketId){
            this.setCityId(this.$route.query.cityId)
            storage.setS("cityId",this.$route.query.cityId)
            this.getWapOpenId({
              jsCode: this.$route.query.code,
              cityId: this.$route.query.cityId
            },{})
          }else{
            this.getWapOpenId({
              jsCode: this.$route.query.code,
              marketId: this.$route.query.marketId || marketId,
              cityId:this.$route.query.cityId || ''
            },{marketId:this.$route.query.marketId || marketId})
          }
        }
      }
    } else {
      setTimeout(() => {
        this.$nextTick(() => {
          this.getFlag(true)
          this.isNetworkOnline =true
        })
        if(this.$route.query.cityId){
          this.setCityId(this.$route.query.cityId)
          this.getMarketListFun(this.$route.query.cityId)
        }
        this.getOpenId('okABn6mrF4WR--mjeqd7BRiEdLec'); //ysy okABn6mrF4WR--mjeqd7BRiEdLec
        // this.getMarketListFun('2')
        this.getMarketInfo({
          cityId: "2",
          cityName: "戴德梁行",
          createTime: 1567583151000,
          id: "2",
          isDrop: 0,
          isOpen: 1,
          isPushMeeting: 0,
          latitude: "31.2181710",
          longitude: "121.3594721",
          marketName: "鲁能国际",
          marketType: 1,
          styleType: 1,
          updateTime: 1582166355000,
          updateUser: "陆彬彬",
          invoiceType:5,
        });
        storage.set('marketId','2')
        this.getTheme('1');
        this.getHolidayStyle('0');//设置全局节假日色
        // this.getUserId('FB6DE3CDB198473DA6A4A9F45376D354');//ysy
        this.getUserId('CAABC5F3D51A44428AA7B4051473260E');
        this.getShareInfo();
        this.getUserInfo({
          account: "13681896117",
          birthday: '',
          cityId: "2",
          company: "上海万翼科技有限公司",
          companyId: "23",
          email: "437912516@qq.com",
          faceImgUrl: "https://shsaasoss.oss-cn-shanghai.aliyuncs.com/spaceup_rst_test/1576062735132.jpg?Expires=3152862738&OSSAccessKeyId=LTAIwmjkKm3OHGdh&Signature=MU63HilPCBU%2FiLEmuht3QxUNlqw%3D",
          gender: 1,
          isDrop: 0,
          isPwd: 0,
          marketId: "2",
          memberCode: "6800967781345919075",
          modelType: 1,
          photoPath: "https://shsaasoss.oss-cn-shanghai.aliyuncs.com/spaceup_rst_test/1575774956142blob?Expires=3152574960&OSSAccessKeyId=LTAIwmjkKm3OHGdh&Signature=%2F4%2F5z%2BdnBBazToZo4f7cwk3I5Gk%3D",
          realName: "1235",
          sendToMHLM: "0",
          sendToVSH: "0",
          // userId: "FB6DE3CDB198473DA6A4A9F45376D354",
          userId:'CAABC5F3D51A44428AA7B4051473260E',
          userName: "用户6117",
          userType: 1
        });//xqrong
        this.getTenantInfo({
          cityId: "2",
          company: "上海万翼科技有限公司",
          companyId: "23",
          createTime: 1567822070000,
          email: "437912516@qq.com",
          id: "79B3A180835D443D8682939A15303CB8",
          isDeafult: 1,
          isDrop: 0,
          marketId: "2",
          openVisitor: 0,
          phone: "17317225230",
          source: "wx",
          status: 1,
          updateTime: 1568017484000,
          updateUser: "18106290070",
          // userId: "FB6DE3CDB198473DA6A4A9F45376D354",
          userId:'CAABC5F3D51A44428AA7B4051473260E',
          userName: "用户6117"
        })
        this.getTenantInfoList([{
          cityId: "2",
          company: "上海万翼科技有限公司",
          companyId: "23",
          createTime: 1567822070000,
          email: "437912516@qq.com",
          id: "79B3A180835D443D8682939A15303CB8",
          isDeafult: 1,
          isDrop: 0,
          marketId: "2",
          department:'商企服务',
          openVisitor: 0,
          phone: "17317225230",
          source: "wx",
          status: 1,
          updateTime: 1568017484000,
          updateUser: "18106290070",
          // userId: "FB6DE3CDB198473DA6A4A9F45376D354",
          userId:'CAABC5F3D51A44428AA7B4051473260E',
          userName: "用户6117"
        }])
      }, 300);
      setTimeout(() => {
        this.createStatistics();
        this.getUserMarketInfo("2")
      }, 400);
    }
  },
  methods: {
    ...mapActions(['getOpenId', 'getUserInfo', 'getUserId', 'getMarketInfo', 'getFlag', 'getTheme','getHolidayStyle', 'getTenantInfo','getTenantInfoList','setCityId','getMarketList','getGoindex']),
    backIndex(){
      var url ='/home'
      if(this.$route.query.cityId){
          url = url +'?cityId=' + this.$route.query.cityId
        }
      this.$router.push(url)
    },
    getWapOpenId(params,header){
      util.showLoading()
      getWapOpenId(params,header).then(res => {
        util.hideLoading()
          console.log(res);
          if (res.res && res.res.code === 10000 && res.body) {
            
            storage.setS("userData",JSON.stringify(res.body))
            this.setUserInfo()
          }else{
            util.showToast(res.res.msg)
          }
        });
    },
    setUserInfo(){
      let userData = JSON.parse(storage.getS("userData"));
      this.getShareInfo();
      this.getOpenId(userData.openid);
      if (userData.tbMarketInfo) {
        this.getMarketInfo(userData.tbMarketInfo);
        this.getTheme(userData.tbMarketInfo.styleType);//设置全局主题色
        this.getHolidayStyle(userData.tbMarketInfo.holidayStyle);//设置全局主题色
      }
      if (userData.userId) {
        this.getUserId(userData.userId);
        this.createStatistics();
      }
      if(storage.getS("cityId")){
        this.setCityId(storage.getS("cityId"))
        this.getMarketListFun(storage.getS("cityId"))
      }else{
        this.getFlag(true)
      }
      if (userData.userInfo) {
        this.getUserInfo(userData.userInfo);
      }
      if (userData.userTenantInfo) {
        this.getTenantInfo(userData.userTenantInfo);
      }
      if (userData.userTenantInfoList && userData.userTenantInfoList.length) {
        this.getTenantInfoList(userData.userTenantInfoList);
      }
    },
    createStatistics(){
        var title =this.$route.meta.title;
        var path =this.$route.path;
        if(path=="/home"){
           title ="首页";
        }
        this.statistics(path, title)
    },
    // 根据业主id获取项目信息
    getMarketListFun(cityId){
      getMarketList({},{cityId:cityId}).then(res=>{
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body && res.body.marketList){
          let marketList = res.body.marketList || [];
          if(!marketList ||marketList.length==0){
            util.showModal('提示', '贵司账号已过期，请联系项目管理员。',false,"知道了", () => {
            })
            return 
          }
          this.getMarketList(marketList)
          let ids = [];
          marketList.forEach(item=>{
            ids.push(item.id)
          })
          // 如果缓存的项目信息不存在该业主下,删除该项目缓存
          let cityId = this.$route.query.cityId || storage.getS('cityId');
          let historyMess = JSON.parse(storage.get("historyMess"+cityId) || '[]');
          if(historyMess.length > 0){
            historyMess.forEach((item,index)=>{
              if(ids.indexOf(item.id) == -1){
                historyMess.splice(index,1)
              }
            })
            storage.set("historyMess"+cityId,JSON.stringify(historyMess))
          }
          // 判断如果是消息模版过来,且该项目没有拿到opendid,根据cityid拿到的用户数据,初始化对应的项目
          let marketItem = '';
          if(this.$route.query.owner == '1'){
            marketList.forEach(item=>{
              if(item.id == this.$route.query.marketId){
                marketItem = item
              }
            })
          }
          if(marketItem){
            this.getMarketInfo(marketItem)
            this.getUserMarketInfo(marketItem.id)
          }else{
            if(historyMess.length > 0){
              this.getMarketInfo(historyMess[0])
              this.getUserMarketInfo(historyMess[0].id)
            }else{
              this.getMarketInfo(marketList[0])
              this.getUserMarketInfo(marketList[0].id)
            }
          }
        }else if(res.res  && res.res.code === 10000 && res.body && !res.body.marketList){
          util.showModal('提示', '贵司账号已过期，请联系项目管理员。',false,"知道了", () => {
          })
          
        }
      })
    },
    getUserMarketInfo(marketId){
      getUserMarketInfo({},{marketId:marketId}).then(res=>{
        console.log(res)
        if(res.res.code === 10000){
          if (res.body.tbMarketInfo) {
              this.getMarketInfo(res.body.tbMarketInfo); //缓存数据有问题 需要重新设置
              this.getTheme(res.body.tbMarketInfo.styleType);//设置全局主题色
              this.getHolidayStyle(res.body.tbMarketInfo.holidayStyle);//设置全局主题色
            }
            if (res.body.userTenantInfo) {
              this.getTenantInfo(res.body.userTenantInfo);
            }
            if (res.body.userTenantInfoList && res.body.userTenantInfoList.length) {
              this.getTenantInfoList(res.body.userTenantInfoList);
            }
            this.getFlag(true)
        }else{
          this.getFlag(true)
        }
      })
    },
    getShareInfo(){
       // console.log( wx)
       var that =this;
      // storage.getS('rootUrl') || decodeURIComponent(wx.signurl())
        var url = storage.getS('rootUrl') || window.location.href.split('#')[0]   //ios 使用缓存的 安卓使用当前的

        let u = window.navigator.userAgent;
        if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
          url = window.location.href.split('#')[0]
        }
        // url ='https://h5.topchainspace.com/parkingService?marketId=2&prkHeaderId=12&VNK=8009863f&code=091iQf0w3L3xgW2OOr2w3lD2hh3iQf0R&state='
        // var list1 = url.split('?');
        // var sCan ='';
        //  if(list1.length>1){
        //     var list2 = list1[1].split('&')
        //     for(var i=0;i<list2.length;i++){
        //       var lins=list2[i]
        //         if(lins.indexOf('code=') > -1){
        //           console.log("code")
        //         }else{
        //           sCan = sCan+ lins+'&'
        //           // if(i!=list2.length-1){
        //           //     sCan = sCan
        //           // }
        //         }
        //     }
        //  }
        //  url = list1[0]+'?'+sCan;
           //      }

        let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else{
          var mid = this.$route.query.marketId || storage.get('marketId') || this.common.marketInfo.id || ''
          params.marketId = mid
        }
        // console.log("url in getShareInfo  " + url)
        // if(url.indexOf('cityId=') > -1){   //有cityId
        //     console.log("has cityId")
        // }else{
        //     if(url.indexOf('marketId=') > -1){ // 有marketId
        //         console.log("has marketId")
        //     }else{
        //        var mid1 = this.$route.query.marketId || storage.get('marketId') || this.common.marketInfo.id || ''
        //        url = list1[0]+'?marketId='+mid1+'&'+sCan;
        //        params.url = url;
        //       console.log("url in getShareInfo  " + url)
        //     }

        // }

        console.log( "getShareInfo  ===  " + JSON.stringify(params) )
        getShareInfo(params).then(res=>{
          // // console.log( "getShareInfo  ===  " + window.location.href.split('#')[0])
           console.log( "getShareInfo  ===  " + JSON.stringify(res) )
           this.isNetworkOnline =true;
          if(res.res && res.res.code === 10000 && res.body&& res.body.appid){
          // util.showToast(  "   res.body.url===    " +res.body.url,60000);
          // wx.init();
           var configMap={
              debug: false,
              appId: res.body.appid , // 必填，公众号的唯一标识
              timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
              nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
              signature: res.body.signature, // 必填，签名
              jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
           }
            wx.config(configMap)
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                // 暂时解决不了 比较慢的iOS手机微信版本 获取的URL问题 所以config失败 使用当前url 再config 一次
                console.log('in error  '+ JSON.stringify(res) );
                var errMsg =  res.errMsg
                 if(errMsg.indexOf('config') > -1 ){
                  that.errorBackconfig();
                 }
            });
            wx.ready(()=>{
                if(url.indexOf('parkingService') > -1 ){ //零停缴费 不分享
                  wx.hideOptionMenu()
                }
                wx.hideMenuItems({
                  menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
                });
            })

          }
        })
    },

    //config 失败后用当前url重新config
    errorBackconfig(){
         var that =this;
      // storage.getS('rootUrl') || decodeURIComponent(wx.signurl())
        var url =  storage.getS('rootUrl')|| window.location.href.split('#')[0]  //ios 使用缓存的 安卓使用当前的

        let u = window.navigator.userAgent;
        if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
          url = window.location.href.split('#')[0]
        }
        // url ='https://h5.topchainspace.com/parkingService?marketId=2&prkHeaderId=12&VNK=8009863f&code=091iQf0w3L3xgW2OOr2w3lD2hh3iQf0R&state='
        // var list1 = url.split('?');
        // var sCan ='';
        //  if(list1.length>1){
        //     var list2 = list1[1].split('&')
        //     for(var i=0;i<list2.length;i++){
        //       var lins=list2[i]
        //         if(lins.indexOf('code=') > -1){
        //           console.log("code")
        //         }else{
        //           sCan = sCan+ lins+'&'
        //           // if(i!=list2.length-1){
        //           //     sCan = sCan
        //           // }
        //         }
        //     }
        //  }
        //  url = list1[0]+'?'+sCan;
           //      }

       let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else{
          var mid = this.$route.query.marketId || storage.get('marketId') || this.common.marketInfo.id || ''
          params.marketId = mid
        }
        // console.log("url in getShareInfo  " + url)
        // if(url.indexOf('cityId=') > -1){   //有cityId
        //     console.log("has cityId")
        // }else{
        //     if(url.indexOf('marketId=') > -1){ // 有marketId
        //         console.log("has marketId")
        //     }else{
        //        var mid1 = this.$route.query.marketId || storage.get('marketId') || this.common.marketInfo.id || ''
        //        url = list1[0]+'?marketId='+mid1+'&'+sCan;
        //        params.url = url;
        //        console.log("url in getShareInfo  " + url)
        //     }

        // }


        getShareInfo(params).then(res=>{
           console.log( "getShareInfo  ===  " + JSON.stringify(res) )
          var configMap={
              debug: false,
              appId: res.body.appid , // 必填，公众号的唯一标识
              timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
              nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
              signature: res.body.signature, // 必填，签名
              jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
           }
            wx.config(configMap)
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                  console.log('in error  '+ JSON.stringify(res) );
            });
            wx.ready(()=>{
                wx.hideMenuItems({
                  menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
                });
            })
        })

    },
    statistics (url, urlTypeName) {
      this.leaveTime = new Date().valueOf();
      let longTime = Math.floor((this.leaveTime - this.enterTime) / 1000)
      let firstLogin = this.firstLogin;
      if (storage.getS('firstLogin')) {
        firstLogin = 0
      }
      let params = {
        'list': [{
          urlPattern: url,
          urlTypeName: urlTypeName,
          firstLogin: firstLogin, // 1首次 0不是
          interfaceType: 4, // 4.H5 , 3.app
          longTime: longTime
        }]
      }
      statistics(params).then(() => {
        storage.setS('firstLogin', '0')
        this.enterTime = new Date().valueOf()
      })
    }
  }
};
</script>

<style lang="less">
@import "./assets/css/common.less";
html{
    background:@colore !important;
}
#app {
    margin: 0 auto;
    position: relative;
    // max-width:960px;
}
.router_Page {
    min-height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
}
//转场动画
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    // -webkit-transform-style: preserve-3d;
    // -webkit-backface-visibility: hidden;
    // -webkit-perspective: 1000;
    // 启用硬件加速
    will-change: transform;
    transition: all 300ms ease-in-out;
}
.slide-right-enter {
    opacity: 0;
    transform: translate(-100%, 0);
    transition-timing-function: ease-in-out;
}
.slide-right-leave-active {
    opacity: 0;
    // 安卓手机上同时进行离开和进入会出现闪白现象，暂时不启用离开动画
    transform: translate(100%, 0);
    transition-timing-function: cubic-bezier(0.5, 0, 1, 1);
}
.slide-left-enter {
    opacity: 0;
    transform: translate(100%, 0);
    transition-timing-function: ease-in-out;
}
.slide-left-leave-active {
    opacity: 0;
    // 安卓手机上同时进行离开和进入会出现闪白现象，暂时不启用离开动画
    transition-timing-function: cubic-bezier(0.5, 0, 1, 1);
    transform: translate(-100%, 0);
}
.backIndex{
  position: fixed;
  bottom:180px;right:0;
  z-index:333;
  width:80px;
  background:rgba(255,255,255,0.7);
  box-shadow:0px 4px 8px 0px rgba(0,0,0,0.06);
  border-radius:8px 0px 0px 8px;
  border:2px solid rgba(234,234,234,1);
  border-right:0;
  img{
    display:block;
    width:44px;height:44px;
    padding:18px;
  }
}
/* Indicator */
.mint-indicator-wrapper {
    padding: 40px !important;
}
// 没有更多了
.noMore {
    margin: 40px 0;
    text-align: center;
}
.noMore_text {
    display: block;
    height: 44px;
    font-size:32px;
    color: #999;
    line-height: 44px;
}
img {
    object-fit: cover;
}
.over_two_lines{
     display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
     white-space: pre-line;
}
::-webkit-scrollbar{display:none; width:0; height: 0;background-color: transparent;}
.viewhtml {
  padding: 40px 28px;
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
</style>
